import { useLazyQuery, useMutation, useQuery } from "@apollo/client/react";
import { Button, Grid } from '@mui/material';
import Chip from '@mui/material/Chip';
import React, { useEffect, useMemo, useState } from 'react';
import { ButtonOptionGroup } from '../../../components/buttonOptionGroup/ButtonOptionGroup';
import DataGridGenerico from '../../../components/dataGrid/DataGridGenerico';
import { generateColumnsDefaultConfiguration } from '../../../components/dataGrid/columnHelpers';
import { TextInput } from '../../../components/textInput/TextInput';
import { useDebounce } from '../../../hooks/useDebounce';


import EditIcon from '@mui/icons-material/Edit';
import { useNavigate } from 'react-router-dom';
import { adaptProveedorDistribuidorArray } from '../../../adapters/proveedorDistribuidorAdapter';
import { adaptDepositoArray } from '../../../adapters/proveedores/depositoAdapter';
import { adaptProveedorArray } from '../../../adapters/proveedores/proveedorAdapter';
import { CustomButton } from '../../../components/customButton/CustomButton';
import { PopoverModal } from '../../../components/popoverModal/PopoverModal';
import { SelectInput } from '../../../components/selectInput/SelectInput';
import { SwitchInput } from '../../../components/switchInput/SwitchInput';
import { CHANGE_STATE_PROVEEDOR_DISTRIBUIDOR } from '../../../data/graphQL/mutations/ProveedorDistribuidor/changeStateProveedorDistribuidor';
import { GET_ALL_DEPOSITO } from '../../../data/graphQL/queries/ProveedorDistribuidor/getAllDeposito';
import { GET_ALL_PROVEEDOR_DISTRIBUIDOR } from '../../../data/graphQL/queries/ProveedorDistribuidor/getAllProveedorDistribuidor';
import { GET_EXPORT_PROVEEDOR_DISTRIBUIDOR } from '../../../data/graphQL/queries/ProveedorDistribuidor/getExportProveedorDistribuidor';
import { GET_PROVEEDOR_DISTRIBUIDOR_BY_ID } from '../../../data/graphQL/queries/ProveedorDistribuidor/getProveedorDistribuidorById';
import { getDateToString } from '../../../utils/convert';
import { usePersistFilters } from "../../../hooks/usePersistFilters";

import './proveedorDistribuidorContent.scss';
import { downloadExcel } from '../../../utils/downloadExcel';

export const ProveedorDistribuidorContent = ({ setChildrenAction }) => {
  const navigate = useNavigate();

  const header = ["Deposito", "Codigo", "Razon Social", "Modalidad", "Activo", "Vencimiento"];

  const [depositos, setDepositos] = useState([]);
  const { data: dataDeposito } = useQuery(GET_ALL_DEPOSITO, {
    variables: {
      where: {
        or: [
          { regional: { eq: true } }]

      }
    }
  });

  useEffect(() => {
    if (!dataDeposito) return;
    const selectedDepositos = adaptDepositoArray(dataDeposito);
    const todos = { id: 0, displayName: 'Todos', name: 'Todos' };

    selectedDepositos.push(todos);
    setDepositos(selectedDepositos);
  }, [dataDeposito]);

  const {
    rows,
    setRows,
    handleChangePaginationStatus,
    paginationStatus,
    totalCount,
    filters,
    handleChangeFilters,
    selectedFilterByStatus,
    selectedDepositoFilter
  } = useGetProveedorDistribuidor();

  useEffect(() => {
    setChildrenAction(() =>
      <div className='proveedor-distribuidor-Content'>
        <CustomButton
          className='custom-button'
          variant='outlined'
          size='small'
          onClick={handleExport}>
          Exportar
        </CustomButton>
        <CustomButton
          size='small'
          disableElevation
          onClick={() => navigate('/buscarProveedorDistribuidor/proveedorDistribuidor')}
          variant='contained'>

          Nuevo
        </CustomButton>
      </div>
    );
  }, [setChildrenAction]);

  const handleClickEditProveedorDistribuidor = async (proveedorDistribuidor) => {
    await getProveedorDistribuidor({
      variables: {
        IdProveedorDistribuidor: proveedorDistribuidor.id
      }
    });
  };

  const initialColumns = [
    {
      headerName: '',
      field: 'action',
      flex: 0.02,
      renderCell: (cellProps) => {
        const { row } = cellProps;
        return (
          <>
            <PopoverModal>
              <div className='popover-modal-content'>
                <div
                  onClick={() => handleClickEditProveedorDistribuidor(row)} aria-hidden='true'
                  className='item-option clickable-option'>

                  <EditIcon className='edit-icon' />
                  <span className='toggle-action'>Editar</span>
                </div>
                <div className='item-option'>
                  <span className='toggle-action'>Activo</span>
                  <SwitchInput
                    onChange={(e) => {
                      changeStateProveedorDistribuidor({
                        variables: {
                          idProveedorDistribuidor: row?.id,
                          state: e.target.checked
                        }
                      });
                      handleChangeFilters('selectedFilterByStatus', e.target.checked ? 1 : 0);
                    }}
                    checked={row?.activo} />

                </div>
              </div>
            </PopoverModal>
          </>);

      }
    },
    {
      field: 'deposito',
      headerName: 'Deposito'
    },
    {
      field: 'codigo',
      headerName: 'Código'
    },
    {
      field: 'razonSocial',
      headerName: 'Razon social',
      flex: 0.4
    },
    {
      headerName: 'Modalidad',
      field: 'modalidad',
      renderCell: (cellProps) => {
        const { row } = cellProps;
        const renderChips = Object.entries(row)?.map(([key, value], index) => {
          if ((key == 'Bulto' || key == 'Km' || key == 'Kilo') && Boolean(value)) {
            return <Chip key={index} label={key} />;
          }
        });

        return renderChips;
      }
    },
    {
      field: 'activo',
      type: 'boolean',
      flex: 0.08,
      headerName: 'Activo'
    },
    {
      headerName: 'Vencimiento',
      field: 'vencimiento',
      flex: 0.15,
      renderCell: (cellProps) => {
        let listaVencimientos = [];
        const { row } = cellProps;

        if (row.vencimientoBulto) listaVencimientos.push(row.vencimientoBulto);
        if (row.vencimientoKilo) listaVencimientos.push(row.vencimientoKilo);
        if (row.vencimientoKM) listaVencimientos.push(row.vencimientoKM);

        return listaVencimientos.length > 0 ? getDateToString(listaVencimientos.reduce((a, b) => a < b ? a : b, 0)) : '';
      }
    }];


  const columns = useMemo(() => generateColumnsDefaultConfiguration(initialColumns), []);

  const [getProveedorDistribuidor, { data: proveedorDistribuidor }] = useLazyQuery(GET_PROVEEDOR_DISTRIBUIDOR_BY_ID, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!proveedorDistribuidor) return;
    navigate('/buscarProveedorDistribuidor/proveedorDistribuidor',
      {
        state: {
          ProveedorDistribuidor: adaptProveedorArray(proveedorDistribuidor)
        }
      });
  }, [proveedorDistribuidor]);

  const [getExportProveedores, { data: exportProveedoresData }] = useLazyQuery(GET_EXPORT_PROVEEDOR_DISTRIBUIDOR, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!exportProveedoresData) return;
    const data = adaptProveedorDistribuidorArray(exportProveedoresData.exportProveedorDistribuidor).map((item) => {
      let listaVencimientos = [];

      if (item.vencimientoBulto) listaVencimientos.push(item.vencimientoBulto);
      if (item.vencimientoKilo) listaVencimientos.push(item.vencimientoKilo);
      if (item.vencimientoKM) listaVencimientos.push(item.vencimientoKM);

      let vencimiento = listaVencimientos.length > 0 ? getDateToString(listaVencimientos.reduce((a, b) => a < b ? a : b, 0)) : '';

      let modalidad = '';
      modalidad = Boolean(item.Bulto) ? ' Bulto ' : '';
      modalidad = modalidad + (Boolean(item.Kilo) ? ' Kilo ' : '');
      modalidad = modalidad + (Boolean(item.Km) ? ' Km ' : '');


      let obj = {
        deposito: item.deposito,
        codigo: item.codigo,
        razonSocial: item.razonSocial,
        modalidad: modalidad,
        activo: Boolean(item.activo) ? 'Activo' : 'Inactivo',
        vencimiento: vencimiento
      };

      return obj;
    });

    downloadExcel({
      fileName: 'Proveedores',
      sheet: "Proveedores",
      tablePayload: {
        header,
        body: data
      }
    });
  }, [exportProveedoresData]);

  const handleExport = () => {
    getExportProveedores();
  };

  const [getProveedores, { data: proveedoresData }] = useLazyQuery(GET_ALL_PROVEEDOR_DISTRIBUIDOR, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!proveedoresData) return;
    setRows(proveedoresData);
  }, [proveedoresData]);

  const [changeStateProveedorDistribuidor] = useMutation(CHANGE_STATE_PROVEEDOR_DISTRIBUIDOR, {
    refetchQueries: () => {
      getProveedores({
        variables: {
          skip: paginationStatus.page * paginationStatus.pageSize,
          take: paginationStatus.pageSize,
          where: {
            and: [
              selectedFilterByStatus < 2 ? { activo: { eq: !Boolean(selectedFilterByStatus) } } : {},
              selectedDepositoFilter > 0 ? { idDeposito: { eq: selectedDepositoFilter } } : {}]

          },
          order: { idProveedorDistribuidor: "DESC" }
        }
      });
    }
  });


  return (
    <div className='assistance-program-container'>
      <Grid
        container
        justifyContent={'space-between'}
        columns={{
          xs: 2,
          md: 8
        }}
        spacing={1}>

        <Grid size={{ xs: 2 }}>
          <TextInput
            placeholder='Buscador'
            value={filters?.searchFilter}
            searchIcon
            onChange={(e) => handleChangeFilters('searchFilter', e.target.value)}
            onClearButtonClick={() => handleChangeFilters('searchFilter', '')} />

        </Grid>
        <Grid size={{ xs: 2 }}>
          <SelectInput
            options={depositos}
            label='Deposito'
            onChange={(e) => handleChangeFilters('selectedDepositoFilter', e.target.value)}
            value={filters?.selectedDepositoFilter}
            name='idDeposito' />

        </Grid>
        <Grid size={{ xs: 1.4 }}>
          <ButtonOptionGroup
            options={['Activos', 'Inactivos', 'Todos']}
            onOptionClick={(v) => handleChangeFilters('selectedFilterByStatus', v)}
            selectedOption={filters?.selectedFilterByStatus} />

        </Grid>
        <Grid size={{ xs: 2.4 }}>
        </Grid>
      </Grid>
      <Grid
        container
        justifyContent={'space-between'}
        columns={{
          xs: 2,
          md: 8
        }}
        spacing={1}
        marginTop={1}>

        <Grid size={{ xs: 8 }}>
          <DataGridGenerico
            columns={columns}
            rows={rows}
            toolbar={false}
            onPageChange={(page) =>
              handleChangePaginationStatus((prev) => ({
                ...prev,
                page: page
              }))
            }
            onPageSizeChange={(pageSize) =>
              handleChangePaginationStatus((prev) => ({
                ...prev,
                pageSize: pageSize,
                page: 0
              }))
            }
            pageSize={paginationStatus.pageSize}
            totalCount={totalCount}
            currentPage={paginationStatus.page} />

        </Grid>
      </Grid>
    </div>);

};


const useGetProveedorDistribuidor = () => {
  const [proveedores, setProveedores] = useState([]);
  const [paginationStatus, setPaginationStatus] = useState({
    pageSize: 10,
    page: 0
  });

  const { filters, handleChangeFilters } = usePersistFilters(
    {
      searchFilter: '',
      selectedFilterByStatus: 0,
      selectedDepositoFilter: 0
    },
    'proveedorDistribuidorFilters'
  );

  const {
    searchFilter,
    selectedFilterByStatus,
    selectedDepositoFilter
  } = filters;

  const debouncedFilterValue = useDebounce(searchFilter, 1000);


  const [getProveedores, { data: proveedoresData, loading: proveedoresLoading }] = useLazyQuery(GET_ALL_PROVEEDOR_DISTRIBUIDOR, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!proveedoresData) return;
    setProveedores(proveedoresData);
  }, [proveedoresData]);

  useEffect(() => {
    if (!proveedoresLoading) {
      getProveedores({
        variables: {
          skip: paginationStatus.page * paginationStatus.pageSize,
          take: paginationStatus.pageSize,
          where: {
            or: [
              { razonSocial: { contains: debouncedFilterValue } },
              { codigoSAP: { contains: debouncedFilterValue } }],

            and: [
              selectedFilterByStatus < 2 ? { activo: { eq: !Boolean(selectedFilterByStatus) } } : {},
              selectedDepositoFilter > 0 ? { idDeposito: { eq: selectedDepositoFilter } } : {}]

          },
          order: { idProveedorDistribuidor: "DESC" }
        }
      });
    }
  }, [selectedFilterByStatus, selectedDepositoFilter, paginationStatus, debouncedFilterValue]);

  return {
    rows: adaptProveedorDistribuidorArray(proveedores?.allProveedorDistribuidor?.items) || [],
    setRows: setProveedores,
    handleChangePaginationStatus: setPaginationStatus,
    paginationStatus,
    totalCount: proveedores?.allProveedorDistribuidor?.totalCount,
    filters,
    handleChangeFilters,
    selectedFilterByStatus,
    selectedDepositoFilter
  };
};